/*
 * 404 fallback. Any unrecognised hash route lands here instead of an
 * empty mount.
 */

export function renderNotFound(mount: HTMLElement): void {
  const card = document.createElement('article');
  card.className = 'card';

  const tag = document.createElement('span');
  tag.className = 'tag tag--outline';
  tag.textContent = '404';
  card.appendChild(tag);

  const heading = document.createElement('h2');
  heading.style.marginTop = 'var(--space-4)';
  heading.textContent = 'Route not found';
  card.appendChild(heading);

  const body = document.createElement('p');
  body.style.marginTop = 'var(--space-3)';
  body.style.color = 'var(--color-text-warm)';
  body.textContent = "We couldn't find that screen. It may have moved or never existed.";
  card.appendChild(body);

  // Anchor (not button) so middle-click / cmd-click still works. We don't
  // call navigate() programmatically — letting the browser update the hash
  // triggers the router via the hashchange listener.
  const link = document.createElement('a');
  link.href = '#/';
  link.className = 'btn btn--primary';
  link.style.marginTop = 'var(--space-5)';
  link.textContent = 'Back home';
  card.appendChild(link);

  mount.appendChild(card);
}
